import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { Confirm, Loading, useGetIdentity, useGetList, useNotify, useRecordContext, useUpdate } from 'react-admin';
import { buttonStyles } from 'src/services/theme';

export const LearnButton = (props: any) => {
  const record: any = useRecordContext(props);
  const [update, { error }] = useUpdate();
  const [isShowInstruction, setIsShowInstruction] = useState<boolean>(false);
  const [isLearning, setIsLearning] = useState<boolean>(false);
  const [isShowConfirmRemove, setIsShowConfirmRemove] = useState<boolean>(false);
  const [selectedReader, setSelectedReader] = useState<any>(null);
  const notify = useNotify();
  const { identity } = useGetIdentity();

  const {
    data: readers,
    isLoading: isLoadingObject,
    error: errorGetObject,
  } = useGetList('object', {
    pagination: { page: 1, perPage: 20 },
    sort: { field: 'name', order: 'ASC' },
    filter: { type: 'NfcCodeTouch', name: 'BAR' },
  });

  const learnNfc = async (reader_id: string) => {
    const mutation = `
      mutation learnNfc($key_id: Int!, $reader_id: String!) {
        learn_nfc(params: { key_id: $key_id, reader_id: $reader_id }) {
          success
          nfc_id
          error
        }
      }
    `;

    const token = identity?.token;
    if (!token) {
      notify('No token', { type: 'error' });
      return;
    }
    const baseApiUrl = process.env.REACT_APP_BASE_API_URL || '';
    const response = await axios({
      url: baseApiUrl,
      method: 'post',
      headers: { Authorization: `Bearer ${token}` },
      data: { query: mutation, variables: { key_id: Number(record.id), reader_id } },
    });

    const result = response.data?.data?.learn_nfc;
    if (!result?.success) {
      throw new Error(result?.error || 'NFC learn failed');
    }
    return result;
  };

  const handleRemoveNfc = async () => {
    update('key', {
      id: record.id,
      data: { nfc_ids: [] },
      previousData: record,
    }).catch(() => {
      notify('NFC remove failed', { type: 'warning' });
    });
  };

  const handleLearn = async (reader_id: string) => {
    setIsLearning(true);
    setIsShowInstruction(true);
    try {
      const result = await learnNfc(reader_id);
      notify(`NFC learn success: ${result.nfc_id}`, { type: 'success' });
    } catch (err: any) {
      notify(err.message || 'NFC learn failed', { type: 'error' });
    } finally {
      setIsLearning(false);
      setIsShowInstruction(false);
    }
  };

  if (isLoadingObject) {
    return <Loading />;
  }
  if (error || errorGetObject) {
    return <p>ERROR</p>;
  }
  return record ? (
    <>
      <Box sx={{ display: 'flex', gap: 1, mt: 4 }}>
        {readers?.flatMap((reader) => (
          <Button
            size="small"
            variant="contained"
            sx={buttonStyles.info}
            key={reader.id}
            disabled={isLearning}
            onClick={() => {
              if (record.nfc_ids?.length > 0) {
                setIsShowConfirmRemove(true);
                setSelectedReader(reader);
              } else {
                handleLearn(reader.id);
              }
            }}
          >
            {reader.name}
          </Button>
        ))}
        <Dialog open={isShowInstruction}>
          <DialogTitle>Learn NFC Tag</DialogTitle>
          <DialogContent sx={{ minWidth: 300 }}>
            <img
              src="learnNFC.png"
              alt="learnNFC"
              width="100%"
              height="100%"
              style={{ objectFit: 'contain', marginBottom: '10px' }}
            />
            <DialogContentText style={{ marginBottom: 35 }}>
              Hold the NFC tag at the location shown on your NFC reader...
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <Confirm
          isOpen={isShowConfirmRemove}
          loading={isLearning}
          title="Learn NFC"
          cancel="Learn new one"
          confirm="Delete and learn"
          content="Do you want to delete existing NFC tag and learn new one?"
          onClose={() => {
            setIsShowConfirmRemove(false);
            handleLearn(selectedReader.id);
          }}
          onConfirm={() => {
            setIsShowConfirmRemove(false);
            handleRemoveNfc();
            handleLearn(selectedReader.id);
          }}
        />
      </Box>
    </>
  ) : null;
};

LearnButton.defaultProps = { label: 'Learn' };
